import React, { useEffect } from "react"
import { graphql, Link } from "gatsby"

import { GatsbyImage } from "gatsby-plugin-image";
import Layout from '../components/layout'
import AboutUs from "../components/AboutUs/AboutUs"
import Breadcrumb from "../components/Global/Breadcrumb"
import Stats from "../components/AboutUs/Stats"

import Slider from "react-slick";

const settings = {

    responsive: [
        {
            breakpoint: 2800,
            settings: {
                arrows: false,
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 6,
                slidesToScroll: 6,
                autoplay: true,
                autoplaySpeed: 2000,
                pauseOnHover: true,
                cssEase: "linear"
            }
        },
        {
            breakpoint: 500,
            settings: {
                arrows: false,
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 2,
                arrows: false,
                slidesToScroll: 2,
                autoplay: true,
                autoplaySpeed: 2000,
                pauseOnHover: true,
                cssEase: "linear"
            }
        },
    ]
};


function AboutUsTemplate(props) {
    console.log(props)
    let data = props.data.wpgraphql;

    console.log(data)

    function getBreadcrumb() {
        let bCrumb = [];
        bCrumb.push({
            text: "Home",
            url: `${props.pageContext.language !== "EL" ? "/" + props.pageContext.language.toLowerCase() : "/"}`
        })
        bCrumb.push({
            text: data.page.breadcrumbAcf.breadcrumbName,
        })
        return bCrumb;
    }

    function constructMetaData(page, currentPage, language) {
        let payload = {
            title: page.seo.title,
            description: page.seo.metaDesc,
            canonical: `https://plusmedical.gr${currentPage}`,
            fbTitle: page.seo.opengraphTitle ? page.seo.opengraphTitle : page.seo.title,
            fbDescription: page.seo.opengraphDescription ? page.seo.opengraphDescription : page.seo.metaDesc,
            fbUrl: `https://plusmedical.gr${currentPage}`,
            fbType: "website",
            locale: language.toLowerCase(),
            image: page.seo.opengraphImage ? page.seo.opengraphImage.sourceUrl : ""
        }
        return payload
    }

    return (
        <div>
            <Layout
                headerMenu={props.pageContext.headerMenu}
                footerMenu={props.pageContext.footerMenu}
                recentPosts = { data.posts }
                currentPage={{ currentPage: props.pageContext.currentPage, language: props.pageContext.languageName }}
                availableVersions={props.pageContext.availablePages}
                metaData={constructMetaData(data.page, props.pageContext.currentPage, props.pageContext.language)}
                services={props.pageContext.servicesCategories}
                examinations={props.pageContext.examinationsCategories}
                preHeader={data.template.contactInformationTemplate}
            >
                <div>
                    {/* <section>
                        <Introduction backImg={data.page.aboutPageAcf.introductionBackgroundImage} title={data.page.aboutPageAcf.introductionHeader} />
                    </section> */}
                    {data.page.breadcrumbAcf.breadcrumbName && (
                        <section>
                            <Breadcrumb list={getBreadcrumb()} image={data.page.breadcrumbAcf.image} h1={data.page.breadcrumbAcf.breadcrumbName} />
                        </section>
                    )}
                    <section>
                        <AboutUs
                            title={data.page.aboutPageAcf.aboutTitle}
                            paragraph={data.page.aboutPageAcf.aboutFirstParagraph}
                            subParagraph={data.page.aboutPageAcf.aboutSecondParagraph}
                            aboutImage={data.page.aboutPageAcf.aboutImage}
                            sectionName={data.page.aboutPageAcf.aboutSectionName}
                            cta={data.page.aboutPageAcf.aboutCta}
                            aboutImageTitle={data.page.aboutPageAcf.aboutImageTitle}
                            aboutImageSubtitle={data.page.aboutPageAcf.aboutImageSubtitle}
                            aboutImageGallery= { data.page.aboutPageAcf.aboutImageGallery}
                        />
                    </section>

                    <section>
                        <Stats
                            data={data.page.aboutPageAcf.statsSectionGroup}
                        />
                    </section>

                    {/* {data.page.aboutPageAcf.carousel && (
                        <section>
                            <div className="py-20 container m-auto" style={{maxWidth:"1170px"}}>
                                <Slider {...settings}>
                                    {data.page.aboutPageAcf.carousel.map((crl, index) => (
                                        <div key={`crl-${index}`} style={{outline:"none!important"}}>
                                            <GatsbyImage
                                                image={crl.image.imageFile.childImageSharp.gatsbyImageData}
                                                alt={crl.image.altText}
                                                className="build-fix-icon ab-car" />
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </section>
                    )} */}

                </div>
            </Layout>
        </div>
    );
}

export default AboutUsTemplate

export const pageQuery = graphql`query GET_ABOUT_US($id: ID!, $language: WPGraphQL_LanguageCodeFilterEnum, $themeTemplateUri: ID!) {
  wpgraphql {
    page(id: $id) {
      seo {
        canonical
        title
        metaDesc
        opengraphDescription
        opengraphTitle
        opengraphImage {
          sourceUrl
        }
      }
      breadcrumbAcf {
        breadcrumbName
        image {
          sourceUrl
          altText
          imageFile {
            childImageSharp {
              gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH, quality: 100)
            }
          }
        }
      }
      aboutPageAcf {
        aboutTitle
        aboutFirstParagraph
        aboutCta {
          label
          url
        }
        aboutImage {
          sourceUrl
          altText
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 535, placeholder: NONE, layout: CONSTRAINED)
            }
          }
        }
        aboutImageTitle
        aboutImageSubtitle
        aboutImageGallery{
            image {
                sourceUrl
                altText
                imageFile {
                    childImageSharp {
                    gatsbyImageData(width: 535, placeholder: NONE, layout: CONSTRAINED)
                    }
                }
            }
        }
        ourTeamTitle
        aboutSectionName
        aboutSecondParagraph {
          icon {
            altText
            sourceUrl
            imageFile {
              childImageSharp {
                gatsbyImageData(width: 38, quality: 100, placeholder: NONE, layout: FIXED)
              }
            }
          }
          description
        }
        statsSectionGroup {
          sectionName
          title
          description
          componentGroup {
            title
            description
            componentFooterText
            componentStats {
              title
              percentage
            }
            image {
              altText
              sourceUrl
              imageFile {
                childImageSharp {
                  gatsbyImageData(width: 535, placeholder: NONE, layout: CONSTRAINED)
                }
              }
            }
          }
        }
        carousel {
          image {
            altText
            sourceUrl
            imageFile {
              childImageSharp {
                gatsbyImageData(width: 150, quality: 100, placeholder: NONE, layout: FIXED)
              }
            }
          }
        }
      }
    }
    teamMembers(
      first: 200
      where: {language: $language, orderby: {field: MENU_ORDER, order: ASC}}
    ) {
      ...OurTeamFragment
    }
    template(id: $themeTemplateUri, idType: SLUG) {
      contactInformationTemplate {
        telephoneNumber
        supportEmail
        hoursLabel
        hoursTitle
        form {
          title
          subTitle
          fullName
          email {
            label
            errorMessage
          }
          subject
          message {
            label
            errorMessage
          }
          telephone {
            label
            errorMessage
          }
          sendButton
        }
        responseMessages {
          success
          failed
        }
      }
    }
    posts(
      first: 2
      where: {language: $language, orderby: {field: DATE, order: ASC}}
    ) {
      ...RecentPostsFragment
    }
  }
}
`
